import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { hexToRgba } from "src/app/common/colorUtils";
import { LabelModel } from "src/app/models/api/common";
import { LabelsHttpService } from "src/app/services/httpServices/labelsHttpService/labels-http.service";
import { NotificationsService } from "src/app/services/infra/notifications/notifications.service";
import { StoreService } from "src/app/services/infra/store/store.service";

export class CreateLabelDialogInputData {
    public allLabels: LabelModel[];
}

@Component({
    selector: "app-create-label-dialog",
    templateUrl: "./create-label-dialog.component.html",
    styleUrls: ["./create-label-dialog.component.scss"],
})
export class CreateLabelDialogComponent {
    public name: string;
    public color = "#D0BAF9";

    constructor(
        public dialogRef: MatDialogRef<CreateLabelDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public inputData: CreateLabelDialogInputData,
        private _labelsHttpService: LabelsHttpService,
        private _store: StoreService,
        private _notificationService: NotificationsService,
    ) {}

    public onClose() {
        this.dialogRef.close();
    }

    public onNameChange(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.name = value.trim();
    }

    public onColorChange(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.color = value;
    }

    public createButtonClick() {
        this.inputData.allLabels.forEach((label: LabelModel) => {
            if (label.displayName === this.name) {
                this._notificationService.info("Label with this name already exists");
                return;
            }
        });
        this._labelsHttpService
            .createLabel({
                displayName: this.name,
                color: this.color,
            })
            .subscribe({
                next: () => {
                    this._store.updateLabels();
                    this._notificationService.success("Label created successfully");
                    this.onClose();
                },
                error: () => {
                    this._notificationService.error("Failed to create label");
                },
            });
    }

    public getLabelTransparentBackgroundColor(): string {
        return hexToRgba(this.color, 0.3);
    }
}
